"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _constants = require("composer-lib/lib/constants");

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Users.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_USERS_SUCCEEDED:
      return _Users.default.fromJS(action.data);

    case _ActionTypes.default.FETCH_USERS_FAILED:
      return state.set('status', _constants.RequestStatus.FAILED);

    case _ActionTypes.default.FETCH_FULL_COMPOSITION_SUCCEEDED:
      return _Users.default.fromJS(action.data.users);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;